<template>
  <div class="tag" @click="goTo">
    <AppLink :to="link" class="tag-text">{{ tag?.name }}</AppLink>
    <span class="tag-count">{{ tag?.expCount }}</span>
  </div>
</template>

<script setup lang="ts">
import { cityTagUrl } from '@/shared/helpers/urls';
import { type TagTypeWithCity } from '@/shared/models/tag';

const props = defineProps<{
  tag: TagTypeWithCity;
}>();

const link =
  props.tag.slug && props.tag.citySlug ? cityTagUrl(props.tag.citySlug, props.tag.citytagId, props.tag.slug) : '/';

const goTo = () => {
  window.location.href = link;
};
</script>

<style lang="scss" scoped>
.tag {
  display: flex;
  height: 32px;
  cursor: pointer;
  background: var(--comp-chips-color-background);
  border-radius: 8px;

  &:hover {
    background: var(--comp-chips-color-background-hovered);
  }
}

.tag-text,
.tag-count {
  @include typography.base-300-300-medium;
}

a {
  color: var(--alias-color-text-default) !important;

  &:hover {
    color: var(--alias-color-text-default) !important;
  }
}

.tag-text {
  padding: var(--alias-space-6) 0 var(--alias-space-6) var(--alias-space-12);
  text-decoration: none;
}

.tag-count {
  padding: var(--alias-space-6) var(--alias-space-12) var(--alias-space-6) var(--alias-space-4);
  color: var(--comp-chips-color-counter);
  border-radius: 0 8px 8px 0;
}
</style>
